// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
    --whiteMain-color: #FFFBF5;
    --blackMain-color: #273137;
    --rosaMain-color: #FF0073;
    --azulMain-color: #284CD9;
    --royalMain-color: #4DB0CF;
    --outletMain-color: #FF8F00;
    --white-color: #FFFFFF;
    --black-experience-color: #1F1F1F;
    --escuro-cinza-color: #342F31;
    --platinum-color: #E3E3E3;
    --platinum2-border-color: #E3E3E3;

    --colorLojaCard: #273137;

    --black-color: #000000;
} 
`, "",{"version":3,"sources":["webpack://./src/assets/css/colors.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,yBAAyB;IACzB,yBAAyB;IACzB,0BAA0B;IAC1B,2BAA2B;IAC3B,sBAAsB;IACtB,iCAAiC;IACjC,6BAA6B;IAC7B,yBAAyB;IACzB,iCAAiC;;IAEjC,wBAAwB;;IAExB,sBAAsB;AAC1B","sourcesContent":[":root{\r\n    --whiteMain-color: #FFFBF5;\r\n    --blackMain-color: #273137;\r\n    --rosaMain-color: #FF0073;\r\n    --azulMain-color: #284CD9;\r\n    --royalMain-color: #4DB0CF;\r\n    --outletMain-color: #FF8F00;\r\n    --white-color: #FFFFFF;\r\n    --black-experience-color: #1F1F1F;\r\n    --escuro-cinza-color: #342F31;\r\n    --platinum-color: #E3E3E3;\r\n    --platinum2-border-color: #E3E3E3;\r\n\r\n    --colorLojaCard: #273137;\r\n\r\n    --black-color: #000000;\r\n} \r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
